import { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";
import style from "./GraficoDetalher.module.css";

const GraficoDetalheAlunos = ({ dados, dataSelecionada, tipo, limiteMinimo, limiteIdeal, onBarClick }) => {
    const chartRef = useRef(null);
    const chartInstanceRef = useRef(null);


    const labels = dados.map((item) =>
        new Date(item.data).toLocaleDateString("pt-BR")
    );

    useEffect(() => {
        if (!dados || dados.length === 0) return;

        const labels = dados.map(item => item.nome);
        const horas = dados.map(item => item.horas ? Number(item.horas.toFixed(2)) : 0);

        const media =
            horas.length > 0 ? horas.reduce((a, b) => a + b, 0) / horas.length : 0;

        if (chartInstanceRef.current) {
            chartInstanceRef.current.destroy();
        }

        const ctx = chartRef.current.getContext("2d");


        chartInstanceRef.current = new Chart(ctx, {
            data: {
                labels,
                datasets: [
                    {
                        type: tipo,
                        label: "Horas por Aluno",
                        data: horas,
                        backgroundColor: "#0B6B9D",
                        borderColor: "#0B6B9D",
                        borderWidth: 2,
                        fill: false,
                        tension: tipo === "line" ? 0.3 : 0,
                        ...(tipo === "bar" && {
                            barThickness: 20,
                            categoryPercentage: 0.8,
                            barPercentage: 0.9,
                        }),
                    },
                    // {
                    //     type: "line",
                    //     label: "Média da Turma",
                    //     data: Array(labels.length).fill(media),
                    //     borderColor: "orange",
                    //     borderDash: [5, 5],
                    //     borderWidth: 2,
                    //     pointRadius: 0,
                    //     fill: false,
                    //     tension: 0,
                    // },
                    {
                        type: "line",
                        label: "Mínimo Requerido (Horas)",
                        data: Array(labels.length).fill(limiteMinimo),
                        borderColor: "red",
                        borderWidth: 2,
                        pointRadius: 0,
                        fill: false,
                        tension: 0,
                    },
                    {
                        type: "line",
                        label: "Ideal (100% Presença)",
                        data: Array(labels.length).fill(limiteIdeal),
                        borderColor: "green",
                        borderDash: [2, 2],
                        borderWidth: 2,
                        pointRadius: 0,
                        fill: false,
                        tension: 0,
                    },
                ]

            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 800,
                    easing: "easeOutQuart",
                },
                plugins: {
                    title: {
                        display: true,
                        text: `Frequência dos Alunos em ${new Date(dataSelecionada).toLocaleDateString("pt-BR")}`,

                        font: { size: 16 },
                    },
                    legend: {
                        labels: {
                            font: { size: 14 },
                        },
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                return `${context.dataset.label}: ${context.formattedValue}h`;
                            },
                        },
                    },
                },
                scales: {
                    x: {

                        ticks: {
                            font: { size: 12 },
                            maxRotation: 45,
                        },
                        grid: {
                            display: false,
                        },
                    },
                    y: {
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: "Horas",
                            font: { size: 14 },
                        },
                        ticks: {
                            stepSize: 1,
                        },
                    },
                },
            },
        });

        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }
        };
    }, [dados, dataSelecionada, tipo, limiteMinimo, limiteIdeal,]);

    return (
        <div className={style.graficoaluno}>
            <canvas ref={chartRef}></canvas>
        </div>
    );
};

export default GraficoDetalheAlunos;
